import { Injectable, EventEmitter } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { environment } from 'src/environments/environment';
import {ApiService} from "@xref/ngx";
import {map} from "rxjs/operators";

export interface Country {
  /*  fetched from login login.xref.com but translation is done locally so translationKey is added immediately after
  fetching

  data sample:
     {
        id: 13,
        country: "Australia",
        phone_code: "+61",
        region: "AU",
        translationKey: "Australia"
      }
  */
  id: number;
  country: string;
  phone_code: string;
  region: string;
  translationKey: string;
}
export interface LiteAccount {
  country: number;
  phoneNumber: string;
  phoneCountry: string;
  organisation: string;
  password: string;
  default_locale: string;
  region: string; // eg. "au"
}

export class SetUpFormErrors {
  ERROR_EMAIL_INVALID: boolean;
  ERROR_EMAIL_EXISTS: boolean;
  ERROR_DOMAIN_INVALID: boolean;
  ERROR_NO_PLUS_CHAR: boolean;
  WARNING_DOMAIN_IS_ENTERPRISE: boolean;
  ERROR_PENDING_VERIFICATION: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  active = false;
  auth_api = `${environment.AUTH_API}`;
  setUpFormErrors = new SetUpFormErrors();
  constructor(
    private http: HttpClient,
    private api: ApiService,
  ) {}

  getCountryDetails() {
    return this.http.get<Array<Country>>(`${this.auth_api}/registration/countries`);
  }

  registerAccount(account: LiteAccount) {
    return this.api.post('v1/register', account);
  }

  resendLinkByEmail(email: string) {
    return this.http.post(`${this.auth_api}/registration/resend-verification-link/email`, {email}).pipe((data) => data);
  }

  show() {
    this.active = true;
  }

  hide() {
    this.active = false;
  }
}
